import {
  K8IntegrationPage,
  K8IntegrationPageProps,
} from "~/pages/integrations/kubernetes/K8IntegrationPage/K8IntegrationPage";

const K8IntegrationEntryPage = ({ scope }: K8IntegrationPageProps) => {
  return <K8IntegrationPage {...{ scope }} />;
};

export default K8IntegrationEntryPage;
